(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredient-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  // Card hover effects
  const cards = document.querySelectorAll('.ingredient-card');
  cards.forEach(card => {
    card.addEventListener('mouseenter', () => card.style.transform = 'translateY(-8px)');
    card.addEventListener('mouseleave', () => card.style.transform = 'translateY(0)');
  });
  
  // Modal functionality
  const showBtn = document.getElementById('showAllIngredients');
  const modal = document.getElementById('ingredientsModal');
  const closeBtn = document.getElementById('closeModal');
  
  if (showBtn && modal) {
    showBtn.addEventListener('click', (e) => {
      e.preventDefault();
      modal.style.display = 'block';
      document.body.style.overflow = 'hidden';
    });
    
    const closeModal = () => {
      modal.style.display = 'none';
      document.body.style.overflow = 'auto';
    };
    
    closeBtn.addEventListener('click', closeModal);
    window.addEventListener('click', (e) => {
      if (e.target === modal) closeModal();
    });
    
    // Keyboard support
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.style.display === 'block') {
        closeModal();
      }
    });
  }

  // Mobile-only auto slider for ingredient cards
  const mobileView = window.matchMedia('(max-width: 750px)');
  const ingredientSections = document.querySelectorAll('.keyingredients_fullsec');

  ingredientSections.forEach((section) => {
    const grid = section.querySelector('.ingredients-grid');
    if (!grid) return;

    const sliderCards = grid.querySelectorAll('.ingredient-card');
    if (sliderCards.length < 2) return;

    let autoSlideInterval;
    let currentIndex = 0;

    const equalizeCardHeights = () => {
      sliderCards.forEach((card) => {
        card.style.minHeight = '';
      });

      if (!mobileView.matches) return;

      let maxHeight = 0;
      sliderCards.forEach((card) => {
        const cardHeight = card.getBoundingClientRect().height;
        if (cardHeight > maxHeight) maxHeight = cardHeight;
      });

      sliderCards.forEach((card) => {
        card.style.minHeight = `${Math.ceil(maxHeight)}px`;
      });
    };

    const stopAutoSlide = () => {
      if (autoSlideInterval) {
        clearInterval(autoSlideInterval);
        autoSlideInterval = null;
      }
    };

    const goToNextSlide = () => {
      if (!mobileView.matches) return;
      currentIndex = (currentIndex + 1) % sliderCards.length;
      sliderCards[currentIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start'
      });
    };

    const startAutoSlide = () => {
      stopAutoSlide();
      if (!mobileView.matches || document.hidden) return;
      autoSlideInterval = setInterval(goToNextSlide, 3500);
    };

    grid.addEventListener('touchstart', stopAutoSlide, { passive: true });
    grid.addEventListener('touchend', startAutoSlide, { passive: true });
    grid.addEventListener('pointerdown', stopAutoSlide);
    grid.addEventListener('pointerup', startAutoSlide);
    grid.addEventListener('mouseenter', stopAutoSlide);
    grid.addEventListener('mouseleave', startAutoSlide);

    grid.addEventListener('scroll', () => {
      if (!mobileView.matches) return;
      let nearestIndex = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;

      sliderCards.forEach((card, index) => {
        const distance = Math.abs(card.offsetLeft - grid.scrollLeft);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });

      currentIndex = nearestIndex;
    }, { passive: true });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopAutoSlide();
      } else {
        startAutoSlide();
      }
    });

    window.addEventListener('resize', () => {
      if (mobileView.matches) {
        equalizeCardHeights();
        startAutoSlide();
      } else {
        stopAutoSlide();
        sliderCards.forEach((card) => {
          card.style.minHeight = '';
        });
        grid.scrollTo({ left: 0 });
        currentIndex = 0;
      }
    });

    const cardImages = grid.querySelectorAll('img');
    cardImages.forEach((img) => {
      img.addEventListener('load', equalizeCardHeights);
    });

    equalizeCardHeights();
    setTimeout(equalizeCardHeights, 300);
    startAutoSlide();
  });
});

  } catch(e) { console.error(e); }
})();
})();
